"use strict";
// TypeScript interfaces for Movie Cache in Firestore
Object.defineProperty(exports, "__esModule", { value: true });
